import React, { useState, useEffect } from 'react';
import moment from 'moment';

const generateDateRange = (startDate, endDate) => {
  let returnDates = [];
  let currentDate = moment(startDate);

  while (currentDate.isSameOrBefore(endDate)) {
    returnDates.push(currentDate.clone());
    currentDate.add(1, 'days');
  }

  return returnDates;
};

const HorizontalCalendar = ({ startDate, endDate, projects, backgroundColor, textColor, scrollView  }) => {
  const [dates, setDates] = useState([]);
  const [dateWidth, setDateWidth] = useState(0);
  console.log("Projects")
  console.log(projects)
  useEffect(() => {
    setDates(generateDateRange(startDate, endDate));
  }, [startDate, endDate]);
  
  useEffect(() => {
    if (dates.length > 0) {
      let containerWidth = window.innerWidth - 50;
        setDateWidth(containerWidth / dates.length);
    }
  }, [dates]);

  return (
    <div id="container" style={{ width: "100%" ,height: "150px", padding: "15px", display: "flex"}}>
      {
        dates.map((date, index) => {
          return (
            
            <div key={index} style={{ background: backgroundColor ? backgroundColor : "black", color: textColor ? textColor : "white", textAlign: "center" , width: dateWidth.toString() + "px", height: "100%", borderRight: "1px solid " + textColor, }}>{date.format('DD')}</div>);
        })
      }
      {
        
        projects.map((project) => {
          console.log(project)
          const projectStartDate = moment(project.startDate);
          const projectEndDate = moment(project.endDate);
          let left = 0;
          // if (projectEndDate.diff(projectStartDate, 'days'))
          console.log("Widths")
          let width = 0;
          // width = ((projectEndDate.diff(projectStartDate, 'days')) * (dateWidth+1))-1;
          
          //Scenarios
          //ProjectStart is before CalendarStart and ProjectEnd is after CalendarEnd
          if (projectStartDate.isSameOrBefore(moment(startDate)) && projectEndDate.isSameOrAfter(moment(endDate))) { 
            width = (dates.length+1) * (dateWidth+1);
            left = 15;
          }
          //ProjectStart is before CalendarStart and ProjectEnd is before CalendarEnd
          if (projectStartDate.isSameOrBefore(moment(startDate)) && projectEndDate.isSameOrBefore(moment(endDate))) { 
            console.log("Scenario 2")
            console.log((projectEndDate.diff(moment(startDate), 'days')))
            width = ((projectEndDate.diff(moment(startDate), 'days')+1) * (dateWidth+1));
            left = 15;
          }
          //ProjectStart is after CalendarStart and ProjectEnd is after CalendarEnd
          if (projectStartDate.isSameOrAfter(moment(startDate)) && projectEndDate.isSameOrAfter(moment(endDate))) { 
            console.log("Scenario 3")
            console.log((moment(endDate).diff(projectStartDate, 'days')))
            width = ((moment(endDate).diff(projectStartDate, 'days')+1) * (dateWidth+1));
            left = (projectStartDate.diff(moment(startDate), 'days') * (dateWidth+1))+15;
          }
          //ProjectStart is after CalendarStart and ProjectEnd is before CalendarEnd
          if (projectStartDate.isSameOrAfter(moment(startDate)) && projectEndDate.isSameOrBefore(moment(endDate))) {
           console.log("Scenario 4")
            console.log((projectEndDate.diff(projectStartDate, 'days'))) 
            width = ((projectEndDate.diff(projectStartDate, 'days')+1) * (dateWidth+1));
            left = (projectStartDate.diff(moment(startDate), 'days') * (dateWidth+1))+15;
          }
          
          // if (projectEndDate.isAfter(moment(endDate)) && ) {
          //   width = ((moment(endDate).diff(projectStartDate, 'days')+1) * (dateWidth+1))-1;
          // 
          
          
          //Determine if the project is within the date range and don't show it if it isnt
          if (projectStartDate.isAfter(moment(endDate)) || projectEndDate.isBefore(moment(startDate))) { 
            return null;
          }

          return (
            <div
              key={project.title}
              style={{
                position: 'absolute',
                left: left,
                width: width,
                height: '120px',
                background: project.backgroundColor ? project.backgroundColor : 'white',
                color: project.textColor ? project.textColor : 'black',
                opacity: 0.90,
                border: '1px solid black',
                marginTop: '30px',
              }}
            >
              <h2>{project.title}</h2>
              <p>{project.status}</p>
            </div>
          );
        })
      }
    </div>
  );
};

export default HorizontalCalendar;
